import { render } from "./DeleteModal.vue?vue&type=template&id=04093b41&scoped=true&ts=true"
import script from "./DeleteModal.vue?vue&type=script&lang=ts"
export * from "./DeleteModal.vue?vue&type=script&lang=ts"

import "./DeleteModal.vue?vue&type=style&index=0&id=04093b41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04093b41"]])

export default __exports__